import React from 'react';
import { RCButton, RCToast } from '@reverbdotcom/cadence/components';
import { withPrefix } from '@reverbdotcom/commons/src/i18n_helpers';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';
import { gql } from '@reverbdotcom/commons/src/gql';

interface Props {
  productReviewId: string;
}

export function ProductReviewAdminBlockButton({ productReviewId }: Props) {
  const [adminBlockProductReview] = useMutation(ADMIN_BLOCK_PRODUCT_REVIEW);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [buttonText, setButtonText] = React.useState(translate('block'));

  async function onClick() {
    await adminBlockProductReview({
      variables: {
        input: {
          productReviewId,
        },
      },
      refetchQueries: ['Core_Product_Reviews'],
      awaitRefetchQueries: true,
    });
    setDisabled(true);
    setButtonText(translate('blocked'));
    setShowSuccess(true);
  }

  return (
    <>
      <RCButton
        data-admin-block
        size="mini"
        variant="filled"
        theme="danger"
        onClick={onClick}
        disabled={disabled}
      >
        {buttonText}
      </RCButton>
      <RCToast isOpen={showSuccess} onClose={() => setShowSuccess(false)} text={translate('blocked')} />
    </>
  );
}

const ADMIN_BLOCK_PRODUCT_REVIEW = gql(`
  mutation Core_AdminBlockProductReview(
    $input: Input_core_apimessages_AdminBlockProductReviewRequest
  ) {
    adminBlockProductReview(input: $input) {
      id
    }
  }
`);

const translate = withPrefix('discovery.productReviews.adminBlock');
